import { render, staticRenderFns } from "./VCAFehlerListe.vue?vue&type=template&id=45d67aaf&scoped=true&"
import script from "./VCAFehlerListe.vue?vue&type=script&lang=ts&"
export * from "./VCAFehlerListe.vue?vue&type=script&lang=ts&"
import style0 from "./VCAFehlerListe.vue?vue&type=style&index=0&id=45d67aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d67aaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
